import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private languageSubject = new BehaviorSubject<string>(sessionStorage.getItem('language') || 'es');
  public language$ = this.languageSubject.asObservable();

  public translations$ = this.language$.pipe(
    switchMap(lang => this.http.get(`assets/i18n/${lang}.json`)),
    shareReplay(1)
  );

  constructor(private http: HttpClient) { }

  public get language(): string {
    return this.languageSubject.value;
  }

  public set language(value: string) {
    this.languageSubject.next(value);
    sessionStorage.setItem('language', value);
  }
}
